// extracted by mini-css-extract-plugin
export default {"error":"ContractDetailErrorMessage_error__kfTUg"};